import { lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Outlet,
} from "react-router-dom";

import ResponsiveDrawer from "../components/ResponsiveDrawer";
import Loader from "../components/Loader";
import { useUser } from "../contexts/UserContext";

const NotFound = lazy(() => import("../pages/NotFound"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Summary = lazy(() => import("../pages/Summary"));
const BillingLedger = lazy(() => import("../pages/BillingLedger"));
const ViewUsers = lazy(() => import("../pages/Admins/viewUsers"));
const ViewResellers = lazy(() => import("../pages/Resellers/ViewResellers"));
const ViewAdmins = lazy(() => import("../pages/Admins/adminView"));
const Users = lazy(() => import("../pages/users/UsersClient"));
const Bills = lazy(() => import("../pages/Bills/BillsView"));
const Expenses = lazy(() => import("../pages/Expenses/ExpensesView"));
const ExpensesHistory = lazy(() => import("../pages/ExpensesHistory"));
const Quotations = lazy(() => import("../pages/Quotation/QuotationView"));
const Technicians = lazy(() => import("../pages/Technicians/TechniciansView"));
const Transaction = lazy(() => import("../pages/Transaction"));
const Notification = lazy(() =>
  import("../pages/Notifications/NotficationView")
);
const AddUser = lazy(() => import("../pages/users/AddUser"));
const AddAdmin = lazy(() => import("../pages/Admins/addAdmin"));
const AddReseller = lazy(() => import("../pages/Resellers/AddReseller"));
const AddTechnician = lazy(() => import("../pages/Technicians/addTechnician"));
const AddBill = lazy(() => import("../pages/Bills/addBill"));
const AddExpense = lazy(() => import("../pages/Expenses/addExpense"));
const UserBillsSummary = lazy(() => import("../pages/Bills/userBillsSummary"));
const ActivateUser = lazy(() => import("../pages/Bills/activateUser"));
const ViewProduct = lazy(() => import("../pages/Products/ViewProduct"));
const AddProduct = lazy(() => import("../pages/Products/addProducts"));
const ViewProductLogs = lazy(() => import("../pages/Products/ViewProductLogs"));
const ViewProductCategory = lazy(() => import("../pages/ProductCategories/ViewProductCategories"));
const AddProductCategory = lazy(() => import("../pages/ProductCategories/addProductCategories"));
const ViewAddresses = lazy(() => import("../pages/Addresses/ViewAddresses"));
const ViewLocations = lazy(() => import("../pages/Locations/ViewLocations"));
const AddAddress = lazy(() => import("../pages/Addresses/addAddress"));
const SendSms = lazy(() => import("../pages/Notifications/sendSms"));
const ViewPermissions = lazy(() =>
  import("../pages/Permissions/ViewPermission")
);
const AddPermission = lazy(() => import("../pages/Permissions/AddPermission"));
const ViewSettings = lazy(() => import("../pages/Settings/ViewSettings"));

const Root = () => {
  console.log("useUser", useUser);
  return (
    <ResponsiveDrawer>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </ResponsiveDrawer>
  );
};

const superAdminRouter = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route index element={<Dashboard />} />
      <Route path="summary" element={<Summary />} />
      <Route path="billing-ledger" element={<BillingLedger />} />
      <Route path="admin-view-users" element={<ViewUsers />} />
      <Route path="resellers" element={<ViewResellers />} />
      <Route path="admins" element={<ViewAdmins />} />
      <Route path="users" element={<Users />} />
      <Route path="bills" element={<Bills />} />
      <Route path="expenses" element={<Expenses />} />
      <Route path="expenses-history" element={<ExpensesHistory />} />
      <Route path="transaction" element={<Transaction />} />
      <Route path="notification" element={<Notification />} />
      <Route path="users/add-user" element={<AddUser />} />
      <Route path="admins/add-admin" element={<AddAdmin />} />
      <Route path="resellers/add-reseller" element={<AddReseller />} />
      <Route path="technicians" element={<Technicians />} />
      <Route path="technicians/add-technician" element={<AddTechnician />} />
      <Route path="bills/add-bill" element={<AddBill />} />
      <Route path="expenses/add-expense" element={<AddExpense />} />
      <Route path="quotations" element={<Quotations />} />
      <Route path="user/bills-summary" element={<UserBillsSummary />} />
      <Route path="bills/activate-user" element={<ActivateUser />} />
      <Route path="Products" element={<ViewProduct />} />
      <Route path="Products/add-product" element={<AddProduct />} />
      <Route path="Products/transfer-logs" element={<ViewProductLogs />} />
      <Route path="Product-category" element={<ViewProductCategory />} />
      <Route path="Product-category/add-category" element={<AddProductCategory />} />
      <Route path="address" element={<ViewAddresses />} />
      <Route path="locations" element={<ViewLocations />} />
      <Route path="address/add-address" element={<AddAddress />} />
      <Route path="notification/send-sms" element={<SendSms />} />
      <Route path="permission" element={<ViewPermissions />} />
      <Route path="permission/add-permission" element={<AddPermission />} />
      <Route path="settings" element={<ViewSettings />} />

      <Route path="*" element={<NotFound location="admin" />} />
    </Route>
  )
);

export default superAdminRouter;
